export default function SectionHeading({ eyebrow, title, sub, align = "left", className = "" }) {
  const alignment = align === "center" ? "items-center text-center" : "items-start text-left";
  return (
    <div className={`flex flex-col ${alignment} max-w-3xl ${align === "center" ? "mx-auto" : ""} ${className}`}>
      {eyebrow && (
        <span className="eyebrow mb-4">
          <span className="inline-block w-8 h-px bg-bronze align-middle mr-3" />
          {eyebrow}
        </span>
      )}
      {title && (
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-ink leading-[1.05] tracking-tight">
          {title}
        </h2>
      )}
      {sub && (
        <p className="mt-6 text-base sm:text-lg text-ink_soft/80 font-light leading-relaxed max-w-2xl">
          {sub}
        </p>
      )}
    </div>
  );
}
